import { NextActionCell } from "components/OverviewPages/siteTableRenderers";
import { DateCell } from "components/SharedTable/tableRenderers";
import { MachineOverview } from "interfaces/machine-overview";
import { CellProps, Column } from "react-table";

export const getMachineTableColumns = (
  hasFeature: (feature: string) => boolean
): Column<MachineOverview>[] => {
  const baseColumns: Column<MachineOverview>[] = [
    {
      Header: "Component",
      id: "component",
      sortType: "siteOverviewMachineSortType",
      accessor: data => data.name
    },
    {
      Header: "Cases Open",
      sortType: "numericalSortType",
      accessor: "open_case_count"
    },
    {
      Header: "Next Action",
      sortType: "stringSortType",
      accessor: "next_action",
      Cell: (cellProps: CellProps<MachineOverview>) =>
        NextActionCell({ value: cellProps.value })
    },
    {
      Header: "Action Due Date",
      id: "next_action_due_date",
      accessor: "next_action_due_date",
      sortType: "dateTimeSortType",
      Cell: (cellProps: CellProps<MachineOverview>) =>
        DateCell({ value: cellProps.value })
    }
  ];

  if (hasFeature("alerts")) {
    // Insert the "Active Alert" column as the third column
    baseColumns.splice(2, 0, {
      Header: "Active Alert",
      sortType: "numericalSortType",
      accessor: "active_alerts"
    });
  }

  return baseColumns;
};
